/** Journey booking toggles from CMS booking_defaults (default on when unset). */

export function isGroupBookingEnabled(journey) {
	if (!journey) return true;
	if (journey.group_enabled === false) return false;
	return journey.booking_defaults?.group_enabled !== false;
}

export function isPrivateBookingEnabled(journey) {
	if (!journey) return true;
	if (journey.private_enabled === false) return false;
	return journey.booking_defaults?.private_enabled !== false;
}

export function filterGroupBookingJourneys(journeys) {
	return (journeys || []).filter(isGroupBookingEnabled);
}

export function filterPrivateBookingJourneys(journeys) {
	return (journeys || []).filter(isPrivateBookingEnabled);
}
